// ABOUTME: Modal for overriding the shipper profile on a single carrier or bundle in echeck.
// ABOUTME: Shipper is fixed (taken from props.selectedShipper); only the profile can be picked.

import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, ButtonBase, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import { getShipperColorSettingsByType } from "../../Streams/StreamShipperSettings";
import SHModal from "../../theme/Modal/SHModal";
import ButtonGroup from "../../theme/buttons/ButtonGroup";
import Shbutton from "../../theme/buttons/Shbutton";
import { DropdownBase } from "../../theme/dropdowns/Dropdown";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";

const MEcheckCarrierShipper = (props) => {
    // props: open, handleClose, selectedShipper, currentShipperProfileId,
    //        onConfirm, onClear
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [selectedShipperProfile, setSelectedShipperProfile] = useState(null);

    let isStandAlone = false;
    if (window.matchMedia('(display-mode: standalone)').matches) {
        isStandAlone = true;
    }

    const selectShipperProfile = (selected) => {
        const shipperProfile = props.selectedShipper?.shipperProfiles?.find(option => option.id === selected);
        if(shipperProfile){
            setSelectedShipperProfile(shipperProfile);
        }
    };

    useEffect(() => {
        if(!props.open) return;
        if(props.selectedShipper && props.currentShipperProfileId){
            const profile = props.selectedShipper.shipperProfiles?.find(p => p.id === props.currentShipperProfileId);
            setSelectedShipperProfile(profile ?? null);
        } else {
            setSelectedShipperProfile(null);
        }
    }, [props.open, props.selectedShipper, props.currentShipperProfileId]);

    const handleSave = () => {
        if(!props.selectedShipper || !selectedShipperProfile) return;
        props.onConfirm({
            shipperId: props.selectedShipper.id,
            shipperProfileId: selectedShipperProfile.id,
            shipperName: props.selectedShipper.name,
            shipperProfileName: selectedShipperProfile.name,
            shipperType: props.selectedShipper.type,
        });
        props.handleClose();
    };

    const handleClear = () => {
        if(props.onClear) props.onClear();
        props.handleClose();
    };

    return (
        <SHModal
            open={props.open}
            onClose={props.handleClose}
        >
            <Box
                sx={{
                    textAlign:"center",
                    paddingY:4,
                    paddingX:5,
                    display:"flex",
                    flexDirection:"column",
                    gap:1
                }}
            >
                <Subheading>{t("update_shipper")}</Subheading>
            </Box>

            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    paddingRight:3,
                    paddingLeft:3,
                    paddingTop:3,
                    paddingBottom:1,
                    borderTopLeftRadius:16,
                    borderTopRightRadius:16,
                    display:"flex",
                    alignItems:"center",
                    gap:1
                }}
            >
                <Box
                    sx={{
                        minHeight:120,
                        position:'sticky',
                        top:0,
                        borderRadius:4,
                        p:1.5,
                        flex:1,
                        boxShadow:`0px 2px 4px ${getShipperColorSettingsByType(props.selectedShipper?.type).streamrulehover}`,
                        border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100]}`,
                        background: getShipperColorSettingsByType(props.selectedShipper?.type).background,
                        transition: 'background-color 0.5s',
                    }}
                >
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"flex-end",
                            justifyContent:'space-between',
                        }}
                    >
                        <Box>
                            <Text color={tokens("white").txt["primary"]}>{t("shipper")}:</Text><br/>
                            <Text color={getShipperColorSettingsByType(props.selectedShipper?.type).base} bold>
                                {props.selectedShipper?.name ?? t("no_selection")}
                            </Text>
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            mt:2,
                            display:"flex",
                            justifyContent:'space-between',
                            alignItems:'flex-end',
                        }}
                    >
                        <Box>
                            <Text color={tokens("white").txt["primary"]}>{t("shipperprofile")}:</Text><br/>
                            <Text color={getShipperColorSettingsByType(props.selectedShipper?.type).base} bold>
                                {selectedShipperProfile?.name ?? t("no_selection")}
                            </Text>
                        </Box>
                        <ButtonBase
                            sx={{
                                width:32,
                                height:32,
                                background: getShipperColorSettingsByType(props.selectedShipper?.type).base,
                                color: getShipperColorSettingsByType(props.selectedShipper?.type).background,
                                borderRadius:5,
                            }}
                        >
                            <DropdownBase
                                key={selectedShipperProfile?.id}
                                transformOrigin={{
                                    vertical: "bottom"
                                }}
                                anchorOrigin={{
                                    vertical:"top"
                                }}
                                displayName={"name"}
                                onChange={(selected) => {
                                    selectShipperProfile(selected);
                                }}
                                noSelection={""}
                                options={props.selectedShipper?.shipperProfiles}
                                selected={selectedShipperProfile?.id ?? -1}
                                closeOnSelection
                                searchOptions={{
                                    enabled:true,
                                    placeholder:t("search")
                                }}
                                valueKey={"id"}
                            >
                                <EditOutlinedIcon/>
                            </DropdownBase>
                        </ButtonBase>
                    </Box>
                </Box>
            </Box>

            <Box
                component="footer"
                sx={{
                    pt:2,
                    width:1,
                    paddingBottom: isStandAlone ? "32px" : "16px",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    paddingRight:3,
                    zIndex:1058,
                    position:"relative",
                    background:`${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    borderBottomLeftRadius:24,
                    borderBottomRightRadius:24,
                    "@media screen and (max-width: 47.9375em)" : {
                        paddingRight:0,
                    }
                }}
            >
                <Shbutton
                    isCancel={true}
                    className={"always-visible"}
                    onClick={props.handleClose}
                    color="primary"
                    variant="text"
                    startIcon={<ArrowRightAltIcon/>}
                >
                    {t("cancel")}
                </Shbutton>
                <ButtonGroup version={2}>
                    {props.currentShipperProfileId &&
                        <Shbutton
                            className={"group-btn"}
                            color={"red"}
                            variant="contained"
                            onClick={handleClear}
                        >
                            {t("delete")}
                        </Shbutton>
                    }
                    <Shbutton
                        className={"group-btn"}
                        color={theme.palette.mode === "dark" ? "primaryGrey": "grey"}
                        variant="contained"
                        onClick={handleSave}
                        disabled={!props.selectedShipper || !selectedShipperProfile}
                    >
                        {t("update")}
                    </Shbutton>
                </ButtonGroup>
            </Box>
        </SHModal>
    );
};

export default MEcheckCarrierShipper;
